import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "p-2" }
const _hoisted_2 = ["onDragstart"]

import { ProjectListed } from "@/apps/page/project/sidebar/sections/tool/project-listed.interface";
import AddTool from "@/apps/page/project/sidebar/sections/tool/AddTool.vue";
import { useState } from "@/store/vuex-composition-mappers";
import { computed } from "vue";
import { PAGE_SECTION_KINDS } from "@/apps/page/services/page.service";


export default /*@__PURE__*/_defineComponent({
  __name: 'AddToolList',
  props: {
    projects: {}
  },
  emits: ["dragStart"],
  setup(__props: any, { emit: __emit }) {


const emit = __emit;

// @ts-expect-error (TODO: fix this)
const { page } = useState("page", ["page"]);
const styleValues = computed(() => page.value.colors || {});

function handleDragStart(event: DragEvent, project: ProjectListed) {
    event.dataTransfer?.setData(
        "new-easypage-section",
        JSON.stringify({
            type: PAGE_SECTION_KINDS.TOOL,
            data: project,
        })
    );
    if (event.dataTransfer) {
        event.dataTransfer.effectAllowed = "copy";
    }

    emit("dragStart");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (project) => {
      return (_openBlock(), _createElementBlock("div", {
        key: project.uuid,
        class: "flex items-center flex-col gap-4 ct-ring-1 hover:ct-ring-brand cursor-move transition-all duration-200",
        draggable: "true",
        onDragstart: (e) => handleDragStart(e, project)
      }, [
        _createVNode(AddTool, {
          project: project,
          styleValues: styleValues.value,
          fontFamily: _unref(page).fontFamily
        }, null, 8, ["project", "styleValues", "fontFamily"])
      ], 40, _hoisted_2))
    }), 128))
  ]))
}
}

})